module.exports = __webpack_public_path__ + "media/images/tour/m/vi-3e624b761bbc007775f8c0f494361dbc.png";